import PendoButton from '../../../components/button/pendo-button.vue.js';
import PendoAddUpdateExtensionAppModal from '../../add-update-extension-app-modal/pendo-add-update-extension-app-modal.vue.js';

var script = {
  name: 'EditExtensionDomainPatterns',
  components: {
    PendoButton,
    PendoAddUpdateExtensionAppModal
  },
  props: {
    app: {
      required: true,
      type: Object
    },
    submissionError: {
      type: Object,
      default: () => {}
    },
    savingDomainPatterns: {
      type: Boolean,
      default: false
    },
    websitesModalAlertLink: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showEditModal: false,
      previousSaveState: this.savingDomainPatterns
    };
  },
  computed: {
    domainPatterns() {
      return this.app.extensionDomainPatterns ? [...this.app.extensionDomainPatterns] : [];
    },
    domainPatternsListString() {
      return this.domainPatterns.length ? this.domainPatterns.join(', ') : 'No websites configured.';
    },
    canUpdateDomainPatterns() {
      return this.app.extensionStructRegExps ? this.app.extensionStructRegExps.length > 0 : false;
    }
  },
  watch: {
    savingDomainPatterns() {
      if (this.previousSaveState && !this.savingDomainPatterns) {
        if (this.submissionError === null || this.submissionError === {}) {
          this.closeEditModal();
        }
      }
      this.previousSaveState = this.savingDomainPatterns;
    }
  },
  methods: {
    editDomainPatterns() {
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    updateDomainPatterns(domainPatterns) {
      this.$emit('update-websites', domainPatterns);
    }
  }
};

export { script as default };
//# sourceMappingURL=edit-extension-domain-patterns.vue2.js.map
